<template>
  <section
    ref="videoSection"
    class="w-full bg-transparent px-4 md:px-8 flex flex-col justify-center items-center min-h-screen"
  >
    <div
      class="w-full max-w-6xl mx-auto py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10"
    >
      <!-- Dynamic Videos -->
      <div
        v-for="(video, index) in videos"
        :key="index"
        class="w-full rounded-3xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-lg p-3 relative transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col min-h-[200px]"
        @click="toggleVideo(video.ref)"
      >
        <video
          :ref="video.ref"
          :src="video.src"
          class="w-full rounded-2xl object-cover aspect-video mb-3"
          playsinline
          autoplay
          muted
        ></video>

        <!-- Description -->
        <p
          class="text-white font-light text-sm text-justify p-2 rounded-lg flex-1"
        >
          {{ video.description }}
        </p>

        <!-- Fullscreen Button -->
        <button
          class="absolute top-[calc(50%+15px)] md:top-[calc(42%+15px)] lg:top-[calc(64%+15px)] right-5 bg-white/20 hover:bg-green1 text-white rounded-full p-2 backdrop-blur-md shadow-md z-30 group"
          @click.stop="toggleFullscreen(video.ref)"
        >
          <svg
            v-if="!fullscreen[video.ref]"
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 3H5a2 2 0 00-2 2v3m0 8v3a2 2 0 002 2h3m8-16h3a2 2 0 012 2v3m0 8v3a2 2 0 01-2 2h-3"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4h6v6H4V4zm10 10h6v6h-6v-6z"
            />
          </svg>

          <!-- Hover Text -->
          <span
            class="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-green-800 bg-white px-2 py-1 rounded-full text-xs font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
          >
            Full Screen
          </span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "VideoSection",
  //   props: {
  //     fullscreen: { type: Object, required: true },
  //     videoStatus: { type: Object, required: true },
  //   },
  data() {
    return {
      videoStatus: {
        video1: false,
        video2: false,
        video3: false,
        video4: false,
        video5: false,
        video6: false,
      },
      fullscreen: {
        video1: false,
        video2: false,
        video3: false,
        video4: false,
        video5: false,
        video6: false,
      },
      videos: [
        {
          ref: "video1",
          src: require("@/assets/img/DNSC In-House Developed Systems Video Presentation.mp4"),
          description:
            "Explore the DNSC In-house Developed Information Systems and learn how our custom-built solutions optimize workflow and enhance efficiency across different departments.",
        },
        {
          ref: "video2",
          src: require("@/assets/img/Information System Gateway.mp4"),
          description:
            "DNSC Information Systems Gateway A Unified Digital Ecosystem, where your seamless and secure access is just a click away.",
        },
        {
          ref: "video3",
          src: require("@/assets/img/DNSC Procurement Management System.mp4"),
          description:
            "Funds, Requisition, and Supply and Inventory System (FRSIS), formerly known as Procurement Management System and Supply and Inventory System.",
        },
        {
          ref: "video5",
          src: require("@/assets/img/Finding your way around.mp4"),
          description:
            "Finding Your Way Around the Learning Management System.",
        },
        {
          ref: "video4",
          src: require("@/assets/img/CORETIME UPDATED.mp4"),
          description:
            "Adding Core Time through the Human Resource Information System.",
        },
        {
          ref: "video6",
          src: require("@/assets/img/Apply in DNSC Page Toturial5.mp4"),
          description: "How to Apply Using the DNSC Online Recruitment System?",
        },
      ],
    };
  },
  methods: {
    toggleVideo(refName) {
      const ref = this.$refs[refName];
      const video = Array.isArray(ref) ? ref[0] : ref;
      if (!video) return;

      if (video.paused) {
        video.muted = false;
        video.play();
        this.$emit("updateVideoStatus", { ref: refName, playing: true });
      } else {
        video.pause();
        this.$emit("updateVideoStatus", { ref: refName, playing: false });
      }
    },
    toggleFullscreen(refName) {
      const ref = this.$refs[refName];
      const video = Array.isArray(ref) ? ref[0] : ref;
      if (!video) return;

      if (!document.fullscreenElement) {
        video.requestFullscreen();
        this.$emit("updateFullscreen", { ref: refName, fullscreen: true });
      } else {
        document.exitFullscreen();
        this.$emit("updateFullscreen", { ref: refName, fullscreen: false });
      }
    },
  },
};
</script>
